/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/sections/homepage/custom-cards-carousel.js":
/*!****************************************************************!*\
  !*** ./zrc/scripts/sections/homepage/custom-cards-carousel.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/swiper.esm.js\");\n/* eslint-disable babel/object-curly-spacing */\n\nvar nameCustomElement = \"custom-cards-carousel\";\nclass CustomCardsCarousel extends window.HTMLElement {\n  connectedCallback() {\n    this.configSlider();\n  }\n  configSlider() {\n    var $sliderContainer = this.querySelector(\".ccc-items\");\n    var $nextButton = this.querySelector(\".swiper-button.next\");\n    var $prevButton = this.querySelector(\".swiper-button.prev\");\n    var swiperSettings = {\n      modules: [swiper__WEBPACK_IMPORTED_MODULE_0__.Navigation],\n      loop: false,\n      slidesPerView: \"auto\",\n      centerInsufficientSlides: true,\n      navigation: {\n        nextEl: $nextButton,\n        prevEl: $prevButton\n      }\n    };\n    new swiper__WEBPACK_IMPORTED_MODULE_0__.default($sliderContainer, swiperSettings);\n  }\n}\nif (!window.customElements.get(nameCustomElement)) {\n  window.customElements.define(nameCustomElement, CustomCardsCarousel);\n}//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiLi96cmMvc2NyaXB0cy9zZWN0aW9ucy9ob21lcGFnZS9jdXN0b20tY2FyZHMtY2Fyb3VzZWwuanMuanMiLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly9mYW50YXNpYXMtbWlndWVsLy4venJjL3NjcmlwdHMvc2VjdGlvbnMvaG9tZXBhZ2UvY3VzdG9tLWNhcmRzLWNhcm91c2VsLmpzP2UzNzgiXSwic291cmNlc0NvbnRlbnQiOlsiLyogZXNsaW50LWRpc2FibGUgYmFiZWwvb2JqZWN0LWN1cmx5LXNwYWNpbmcgKi9cbmltcG9ydCBTd2lwZXIsIHsgTmF2aWdhdGlvbiB9IGZyb20gXCJzd2lwZXJcIjtcblxuY29uc3QgbmFtZUN1c3RvbUVsZW1lbnQgPSBcImN1c3RvbS1jYXJkcy1jYXJvdXNlbFwiO1xuY2xhc3MgQ3VzdG9tQ2FyZHNDYXJvdXNlbCBleHRlbmRzIHdpbmRvdy5IVE1MRWxlbWVudCB7XG4gIGNvbm5lY3RlZENhbGxiYWNrKCkge1xuICAgIHRoaXMuY29uZmlnU2xpZGVyKCk7XG4gIH1cblxuICBjb25maWdTbGlkZXIoKSB7XG4gICAgY29uc3QgJHNsaWRlckNvbnRhaW5lciA9IHRoaXMucXVlcnlTZWxlY3RvcihcIi5jY2MtaXRlbXNcIik7XG4gICAgY29uc3QgJG5leHRCdXR0b24gPSB0aGlzLnF1ZXJ5U2VsZWN0b3IoXCIuc3dpcGVyLWJ1dHRvbi5uZXh0XCIpO1xuICAgIGNvbnN0ICRwcmV2QnV0dG9uID0gdGhpcy5xdWVyeVNlbGVjdG9yKFwiLnN3aXBlci1idXR0b24ucHJldlwiKTtcblxuICAgIGNvbnN0IHN3aXBlclNldHRpbmdzID0ge1xuICAgICAgbW9kdWxlczogW05hdmlnYXRpb25dLFxuICAgICAgbG9vcDogZmFsc2UsXG4gICAgICBzbGlkZXNQZXJWaWV3OiBcImF1dG9cIixcbiAgICAgIGNlbnRlckluc3VmZmljaWVudFNsaWRlczogdHJ1ZSxcbiAgICAgIG5hdmlnYXRpb246IHtcbiAgICAgICAgbmV4dEVsOiAkbmV4dEJ1dHRvbixcbiAgICAgICAgcHJldkVsOiAkcHJldkJ1dHRvbixcbiAgICAgIH0sXG4gICAgfTtcblxuICAgIG5ldyBTd2lwZXIoJHNsaWRlckNvbnRhaW5lciwgc3dpcGVyU2V0dGluZ3MpO1xuICB9XG59XG5cbmlmICghd2luZG93LmN1c3RvbUVsZW1lbnRzLmdldChuYW1lQ3VzdG9tRWxlbWVudCkpIHtcbiAgd2luZG93LmN1c3RvbUVsZW1lbnRzLmRlZmluZShuYW1lQ3VzdG9tRWxlbWVudCwgQ3VzdG9tQ2FyZHNDYXJvdXNlbCk7XG59XG4iXSwibWFwcGluZ3MiOiI7O0FBQUE7QUFDQTtBQUVBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFFQTtBQUNBO0FBQ0E7QUFDQTtBQUVBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBRUE7QUFDQTtBQUNBO0FBRUE7QUFDQTtBQUNBIiwic291cmNlUm9vdCI6IiJ9\n//# sourceURL=webpack-internal:///./zrc/scripts/sections/homepage/custom-cards-carousel.js\n");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"custom-cards-carousel": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/sections/homepage/custom-cards-carousel.js","custom-commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkfantasias_miguel"] = self["webpackChunkfantasias_miguel"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;